export default (string) => {
  return string.slice(-2);
};
